import Tracker from "../prop-trackers/tracker.js";
import PropTracker from "../prop-trackers/prop-tracker.js";
import ConsumingDictMux from "./consuming-dict-mux.js";

class DictMux extends Tracker {
    constructor(userdata) {
        super();

        this._sourceTracker = new PropTracker();
        this._keyTracker = new PropTracker();

        this._outputDictMux = new ConsumingDictMux(this._sourceTracker, this._keyTracker, userdata);

        const needsUpdate = () => this.protected_needsUpdate();
        this._outputDictMux.listenNeedsUpdate(needsUpdate);
    }

    setSource(source, sourceEvents) {
        this._sourceTracker.track(source, sourceEvents);
    }

    setKeys(keys, keyEvents) {
        this._keyTracker.track(keys, keyEvents);
    }

    protected_startUpdate() {
        return this._outputDictMux.startUpdate();
    }

    protected_finishUpdate() {
        this._outputDictMux.finishUpdate();
    }
}

export default DictMux;
